import ppeBusiness from "ppe-business";

export default {
    methods: {
      hasBack : function() {
        //console.warn("router.currentRoute", this.$router.currentRoute)
        if(!this.$router.currentRoute.query) return false
        if(this.$router.currentRoute.query.redirectUrl) return true;
        return false;
      },
      
      urlBack : function() {
        if( this.$router.currentRoute.query )
          return { path:this.$router.currentRoute.query.redirectUrl }
        return { }  
      },
      
      urlWithRedirect : function(url, optionalParamToReplace, optionalValueToReplace) {
        
        if( this.$router.currentRoute.fullPath !== url) {
          if(optionalParamToReplace) {
            let fullPath = this.$router.currentRoute.fullPath
            if( this.$router.currentRoute.query[optionalParamToReplace] ) {
              let searchValue = this.$router.currentRoute.query[optionalParamToReplace]
              fullPath = fullPath.replace(optionalParamToReplace+"="+searchValue, optionalParamToReplace+"="+optionalValueToReplace)
            } else {
              fullPath = fullPath + (fullPath.includes("?") ? "&":"?") + optionalParamToReplace + "=" + optionalValueToReplace
            }
            return { path:url, query: {redirectUrl : fullPath } }  
          }
          return { path:url, query: {redirectUrl : this.$router.currentRoute.fullPath } }
        }
        return { path:url }
      },
      
      
      // Helper fonction to redirect to current page
      getRedirectUrl : function() {
          return "redirectUrl=" + this.$router.currentRoute.path
      },

      router: function () {
        return this.$router
      },

      getCardStyle : function(status) {
        switch(status) {
          case 'valid': return "border-left: 20px solid #87CB16;"; 
          case 'doing': return "border-left: 20px solid #FF9500;"; 
          case 'draft': return "border-left: 20px solid #FF4A55;"; 
          case 'received': return "border-left: 20px solid #4880F3;"; 
          case 'done': return "border-left: 20px solid #2366EB;"; 
        }
        return ""
      },

      partnerOrManagerText() {
        if(this.$usermanager.isUserInGroup(ppeBusiness.GROUP.PARTNER))
          return ppeBusiness.getGroupLabel(ppeBusiness.GROUP.PARTNER)
        if(this.$usermanager.isUserInGroup(ppeBusiness.GROUP.MANAGER))
          return ppeBusiness.getGroupLabel(ppeBusiness.GROUP.MANAGER)
        return ""
      },

      isAdmin() {
        return this.$usermanager.isAdmin()
      },

      isPartner() {
        return this.$usermanager.isUserInGroup(ppeBusiness.GROUP.PARTNER)
      },
      isManager() {
        return this.$usermanager.isUserInGroup(ppeBusiness.GROUP.MANAGER)
      },

      isAdminManagerOrPartner() {
        return this.isAdmin() || this.isPartner() || this.isManager()
      },

      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },

      /*editMode : function() {
        let editables = document.querySelectorAll("[key]")

      },*/
      }
}
